<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Tabs :animated="false">
      <TabPane label="订单详情">
        <Divider orientation="left" class="margin-top">基本信息</Divider>
        <Row :gutter="12">
          <Col span="8">
            <sl-label title="订单状态" :content="data.info.orderStateText" />
          </Col>
          <Col span="8">
            <sl-label title="支付方式" :content="data.paymentOrderEasyVO.payTypeText" />
          </Col>
          <Col span="8">
            <sl-label title="订单金额" :content="'￥'+data.info.totalAmount" />
          </Col>
          <Col span="8">
            <sl-label title="下单时间" :content="data.info.dealDatetimeText" />
          </Col>
          <Col span="8" v-if="data.info.orderState == 8">
            <sl-label title="取消时间" :content="data.info.cancelDatetimeText" />
          </Col>
          <Col span="8" v-if="data.info.orderState >= 4 && data.info.orderState < 8">
            <sl-label title="支付时间" :content="data.paymentOrderEasyVO.gmtPaymentText" />
          </Col>
          <Col span="8">
            <sl-label title="总运费" :content="'￥'+data.info.postFee" />
          </Col>
        </Row>

        <Divider orientation="left" class="margin-top">商品信息</Divider>

        <sl-table ref="table" :enable-pager="false" :columns="goodsTable.columns" :data="goodsTable.data"></sl-table>

        <Divider orientation="left" class="margin-top" v-if="data.info.isStages">金融方案</Divider>

        <Row :gutter="12" v-if="data.info.isStages">
          <Col span="8">
            <sl-label title="方案名称" :content="data.finance.name" />
          </Col>
          <Col span="8">
            <sl-label title="金额" :content="data.finance.price" />
          </Col>
          <Col span="8">
            <sl-label title="资金方" :content="data.finance.companyCode" />
          </Col>
          <Col span="8">
            <sl-label title="分期月数" :content="data.finance.stagesMonth" />
          </Col>
           <Col span="8">
            <sl-label title="结算方式" :content="data.finance.clearingTypeText" />
          </Col>
          <Col span="8">
            <sl-label title="借款日期" :content="data.finance.borrowingDatetimeText" />
          </Col>
          <Col span="8">
            <sl-label title="计费开始日" :content="data.finance.repaymentStartDatetimeText" />
          </Col>
          <Col span="8">
            <sl-label title="还款截止日" :content="data.finance.repaymentEndDatetimeText" />
          </Col>
        </Row>

      </TabPane>
      <TabPane label="购买人">
        <Divider orientation="left" class="margin-top">用户信息</Divider>
        <Row :gutter="12" type="flex">
          <Col span="8">
            <sl-label title="姓名" :content="data.buyer.name" />
          </Col>
          <Col span="8">
            <sl-label title="联系电话" :content="data.buyer.phone" />
          </Col>
          <Col span="8">
            <sl-label title="所属企业" :content="data.buyer.companyName" />
          </Col>
          <Col span="8">
            <sl-label title="身份证" :content="data.buyer.idNumber" />
          </Col>
          <Col span="8">
            <sl-label title="收货人姓名" :content="data.buyer.consigneeName" />
          </Col>
          <Col span="8">
            <sl-label title="收货人电话" :content="data.buyer.consigneePhone" />
          </Col>
          <Col span="24">
            <sl-label title="收货地址" :content="data.buyer.fullAddress" />
          </Col>
        </Row>

      </TabPane>
     
      <TabPane label="订单记录">
        <order-flow-log :data="flowData"></order-flow-log>
      </TabPane>
      
    </Tabs>
    <Spin size="large" fix v-if="loading"></Spin>
  </sl-side-panel>
</template>
<script>
import orderFlowLog from './partial/flowLog'

const goodsSpecConv = (data)=>{
  let ret = ''
  try{
    let json = JSON.parse(data)
    ret = json.map(i=>(i.specName+'：'+i.specKey)).join(' , ')
  }catch(e){}
  return ret
}

export default {
  components:{ orderFlowLog },
  data() {
    return {
      loading: true,
      id: null,
      modalVisible:false,
      data:{
        info:{} , 
        finance:{},
        insurance:{},
        goods:{},
        buyContract:{},
        buyer:{},
        paymentOrderEasyVO:{}
      },
      flowData:[],
      goodsTable:{
        data:[],
        columns:[
          {
            title:'商品名称',
            key:'skuName',
          },
          {
            title: 'SKU编码',
            key: 'skuCode'
          },
          {
            title: '商品数量',
            key: 'goodsNum'
          },
          {
            title: '商品规格',
            key: 'goodsSpecText'
          },
        ]
      },
      logTable:{
        data:[],
        columns:[
          {
            title:'操纵时间',
            key:'createDatetimeText',
          },
          {
            title: '操作人',
            key: 'operateUser'
          },
          {
            title: '操作说明',
            key: 'operateMsg'
          },
          {
            title: '原数据',
            key: 'changeBefore'
          },
          {
            title: '新数据',
            key: 'changeAfter'
          },
        ]
      },
      flowLogTable:{
        data:[]
      }
    }
  },

  computed:{
    itemTitle(){
      return '订单编号：' + this.data.info.orderNo
    }
  },
  mounted() {},

  methods: {
    query() {
      if (this.id) {
        this.loading = true
        this.$request.order(this.id).then(resp => {
          if( !resp.code ){
            resp.data.paymentOrderEasyVO = resp.data.paymentOrderEasyVO || {}
            this.$utils.conv(resp.data.info,{'dealDatetime':'datetime' , 'cancelDatetime':'datetime','orderState':'$goodsOrderState', 'flowState':'$flowState' , 'payType':'$payType'})
            this.$utils.conv(resp.data.finance,{'createDatetime':'time' , 'clearingType':'$clearingType','borrowingDatetime':'time','repaymentStartDatetime':'time','repaymentEndDatetime':'time'})
            this.$utils.conv(resp.data.logs,{'createDatetime':'time'})
            this.$utils.conv(resp.data.flowLogs,{'createDatetime':'time'})
            this.$utils.conv(resp.data.goods,{'goodsSpec':goodsSpecConv})
            this.$utils.conv(resp.data.paymentOrderEasyVO,{'payType':'$payType','gmtPayment':'datetime'})

            console.log(resp.data,'<<<')
            resp.data.buyContract = resp.data.buyContrac || {}
            resp.data.insurance = resp.data.insurance || {}
            
            resp.data.goods.goodsSpecDesc = JSON.parse(resp.data.goods.goodsSpec || '[]').map(i=>`${i.specName}: ${i.specKey}`).join(', ')

            resp.data.finance = resp.data.finance || {}

            resp.data.buyer = resp.data.buyer || {}

            resp.data.finance.stagesMonth = resp.data.finance.stagesYear

            if(resp.data.buyContract.downloadUrl){
              resp.data.buyContract.downloadUrl = this.$request.contractDownloadUrl(resp.data.buyContract.id)
            }

            if(resp.data.buyer){
              resp.data.buyer.fullAddress = resp.data.buyer.city + resp.data.buyer.area + resp.data.buyer.address
            }

            this.data = resp.data

            let orderState = resp.data.info.orderState

            const flowData = [
              {createDatetime:resp.data.info.dealDatetime , remark:'买家下单'}
            ]
            if(resp.data.paymentOrderEasyVO.gmtPayment ){
              flowData.push({createDatetime:resp.data.paymentOrderEasyVO.gmtPayment , remark:'买家付款'} )
            }

            if(resp.data.logistics.createDatetime ){
              flowData.push({createDatetime:resp.data.logistics.createDatetime , remark:'卖家发货'} )
            }

            if(resp.data.info.cancelDatetime ){
              flowData.push({createDatetime:resp.data.info.cancelDatetime , remark:'取消订单'} )
            }

            if(resp.data.info.modifyDatetime && orderState == 7 ){
              flowData.push({createDatetime:resp.data.info.modifyDatetime , remark:'订单完成'} )
            }

            this.logTable.data = resp.data.logs || []
            this.flowLogTable.data = resp.data.flowLogs || []
            this.goodsTable.data = resp.data.goods || []
            this.loading = false
            this.flowData = flowData
          }
        })
      }
    },

    init( id ){
      this.reset()
      this.id = id
      this.modalVisible = true
      this.query()
    }, 

    reset(){

      this.data = {
        info:{} , 
        finance:{},
        insurance:{},
        goods:{},
        buyContract:{},
        buyer:{},
        paymentOrderEasyVO:{}
      }
    },

    handleClose() {
      this.$emit('on-update')
    },

    handleDownloadContract(){

    }
  }
}

</script>

<style lang='scss' scoped>
  .margin-top{
    margin-top:35px;
  }
</style>